export default __webpack_public_path__ + "static/media/remeet-image-2.7224b7d7.png";